/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography2, breakpoints, typography2 } from '@coursera/cds-core';

const styles = {
  section: css`
    & + & {
      margin-top: var(--cds-spacing-200);
    }
  `,
  sectionContent: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-150);
  `,
  sectionTitle: css`
    ${breakpoints.down('xs')} {
      ${typography2.subtitleMedium};
    }
  `,
};

type Props = {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const Section = React.forwardRef<HTMLDivElement, Props>(({ children, title, className, style }, ref) => {
  return (
    <section css={styles.section} className={className} style={style} ref={ref}>
      <PageGridContainer>
        <Grid item xs={12} css={styles.sectionContent}>
          {title && (
            <Typography2 variant="subtitleLarge" component="h2" css={styles.sectionTitle}>
              {title}
            </Typography2>
          )}
          {children}
        </Grid>
      </PageGridContainer>
    </section>
  );
});

export default Section;
